import { NotFound } from '@/components/Pages/Errors/NotFound';
import { MedicalConsultation } from '@/features/medicalConsultation/index';
import { QRCode } from '@/features/misc/QRCode';
import { QueryStringRouteManage } from '@/features/misc/QueryStringRouteManager';
import { MynumberUrls } from '@/features/mynumber/constants/urls';
import { Mynumber, Success } from '@/features/mynumber/routes';
import MypageForm from '@/features/mypage/components/Index';
import { OutPatientFallback } from '@/features/reservation/components/OutPatientFallback';
import { ReservationUrls } from '@/features/reservation/constants/urls';
import { registrationRoutes, ReservationForm } from '@/features/reservation/routes';
import { ReviewForm } from '@/features/review';
import MedicalHealthInformationPage from '@/features/medicalHealthInformation/Page';
import { TopPage, QRPage } from '@/features/top';
import { FacilityListForm } from '@/features/facilityList';
import Agreement from '@/features/agreement/components/Agreement';
import InAppNotificationIndex from '@/features/InAppNotification/components/Index';
import NotificationFacilityList from '@/features/InAppNotification/components/FacilifyListForNotifications';
import { NotUserRegistration } from '@/features/reservation/components/NotUserRegistration';
import { ReservationFormMemberstatus } from '@/features/reservation/components/IndexMemberstatus';
import { Navigate } from 'react-router-dom';
import { Webview } from '@/features/mynumber/components/Webview';
import { MedicalInterviewPage } from '@/features/medicalInterview';

export const protectedRoutes = [
  ...registrationRoutes,
  { path: '/patient/medical-consultation', element: <MedicalConsultation /> },
  { path: ReservationUrls.Reservation, element: <ReservationForm isLogin={true} /> },
  { path: ReservationUrls.ReservationMemberstatus, element: <ReservationFormMemberstatus /> },
  { path: '/patient/mypage', element: <MypageForm /> },
  { path: '/patient/review', element: <ReviewForm /> },
  { path: '/patient/medical-health-information', element: <MedicalHealthInformationPage /> },
  { path: '/patient/top', element: <TopPage /> },
  { path: '/patient/top/qrcode', element: <QRPage /> },
  { path: '/patient/facilities', element: <FacilityListForm /> },
  { path: '/qrcode', element: <QRCode /> },
  { path: '/auth/redirect', element: <QueryStringRouteManage /> },
  { path: ReservationUrls.OutpatientFallback, element: <OutPatientFallback /> },
  { path: MynumberUrls.Mynumber, element: <Mynumber /> },
  { path: MynumberUrls.Success, element: <Success /> },
  { path: MynumberUrls.Webview, element: <Webview /> },
  // { path: '/*', element: <Navigate to="/patient/reservation" /> }
  { path: '/patient/notifications/facilities', element: <NotificationFacilityList /> },
  { path: '/notifications/facilities/:facilityId', element: <InAppNotificationIndex /> },
  { path: '/patient/agreement', element: <Agreement /> },
  { path: ReservationUrls.Root, element: <ReservationForm isLogin={true} /> },
  { path: ReservationUrls.NotRegistration, element: <NotUserRegistration /> },
  { path: '/transferSignUp', element: <Navigate to="/patient/top" /> },
  { path: '/patient/medical-interview', element: <MedicalInterviewPage /> },
  { path: '/*', element: <NotFound /> }
];

export default protectedRoutes;
